<template>
  <div class="loading-content" :style="{height: this.GLOBAL.pageHeight + 'px'}" v-if="show">
    <div id="loading">
      <div class="loader-inner ball-beats">
        <div style="background-color: #F7B0B3"></div>
        <div style="background-color: #ED4E54"></div>
        <div style="background-color: #F7B0B3"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLoading',
  data () {
    return {
      show: false
    }
  }
}
</script>

<style scoped>
  .loading-content {
    width: 100%;
    background-color: #fff;
    position: absolute;
    top: 0px;
  }
  #loading {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translateY(-50%) translateX(-50%);
  }
  @-webkit-keyframes ball-beat {
    50% {
      opacity: .2;
      transform: scale(.75);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  @keyframes ball-beat {
    50% {
      opacity: .2;
      transform: scale(.75);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
  .ball-beats > div {
    overflow: hidden;
    background-color: #279fcf;
    width: 10px;
    height: 10px;
    border-radius: 5px !important;
    margin: 2px;
    animation-fill-mode: both;
    display: inline-block;
    animation: ball-beat 0.7s 0s infinite linear;
  }
  .ball-beats > div:nth-child(2n -1) {
    animation-delay: .35s;
  }
</style>



// WEBPACK FOOTER //
// src/plugins/pageLoading/PageLoading.vue